import { HelpYouBuy } from 'shared/landingBuyer/components/HelpYouBuy';
import { useWithModalForm } from 'shared/common/hooks/useWithModalForm';

export const HelpYouBuyContainer: React.FC = () => {
  const { handleOpenModal, device } = useWithModalForm();

  return <HelpYouBuy onOpenModal={handleOpenModal} device={device} />;
};
